export const Config = {
  ENV: import.meta.env.VITE_ENVIRONMENT as "dev" | "demo" | "prod",

  BASE_URL: (import.meta.env.VITE_BASE_URL as string) ?? "",

  WEB_URL: (import.meta.env.VITE_WEB_URL as string) ?? "",

  HIDE_BODY_REQUEST_LOG: (import.meta.env.VITE_HIDE_BODY_REQUEST_LOG as string) ?? "false",

  MOBILE_URL: (import.meta.env.VITE_MOBILE_URL as string) ?? "",

  // Sentry
  SENTRY_DSN: "https://a7d10bd3d49e4a0ba97ad7518cff23ae@o4505362867486720.ingest.sentry.io/4505426181226496",
  SENTRY_ENV: import.meta.env.VITE_SENTRY_ENV as string,

  // Authentification
  COGNITO_USER_POOL_ID: (import.meta.env.VITE_COGNITO_USER_POOL_ID as string) ?? "",
  COGNITO_CLIENT_ID: (import.meta.env.VITE_COGNITO_CLIENT_ID as string) ?? "",

  // Analytics
  SEGMENT_ID: "",

  // Chat
  STREAM_CHAT_API_KEY: (import.meta.env.VITE_STREAM_CHAT_API_KEY as string) ?? "",
  STREAM_CHAT_PUSH_PROVIDER_NAME: "",

  // MAPBOX
  MAPBOX_API_KEY: (import.meta.env.VITE_MAPBOX_API_KEY as string) ?? "",

  // AWS
  AWS_REGION: (import.meta.env.VITE_AWS_REGION as string) ?? "",

  AWS_VIDEO_UPLOAD: (import.meta.env.VITE_AWS_VIDEO_UPLOAD as string) ?? "",

  // Firebase
  FIREBASE_API_KEY: import.meta.env.VITE_FIREBASE_API_KEY as string,
  FIREBASE_AUTH_DOMAIN: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string,
  FIREBASE_PROJECT_ID: import.meta.env.VITE_FIREBASE_PROJECT_ID as string,
  FIREBASE_STORAGE_BUCKET: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET as string,
  FIREBASE_MESSAGING_SENDER_ID: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID as string,
  FIREBASE_APP_ID: import.meta.env.VITE_FIREBASE_APP_ID as string,
  FIREBASE_MEASUREMENT_ID: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID as string,

  // App banner
  IOS_APP_ID: import.meta.env.VITE_IOS_APP_ID as string,
  APP_BANNER_URL: import.meta.env.VITE_ANDROID_APP_BANNER_URL as string,

  // Sanity
  SANITY_PREVIEW_TOKEN: (import.meta.env.SANITY_PREVIEW_TOKEN as string) ?? "",

  //Email Adress
  CONTACT_EMAIL: (import.meta.env.VITE_CONTACT_EMAIL as string) ?? "",

  // CDN
  CDN_FLAG: (import.meta.env.VITE_CDN_FLAG as string) ?? "",

  // Help Center
  HELP_CENTER_URL: "https://hustleuphelp.zendesk.com/hc",

  // Crossfit Affiliate Programming ID
  CROSSFIT_AFFILIATE_PROGRAM_ID: (import.meta.env.VITE_CROSSFIT_AFFILIATE_PROGRAM_ID as string) ?? "",
}
